<div class="notif-overlay" *ngIf="isOpen" (click)="onClose()" aria-hidden="true"></div>
<aside class="notif-drawer" *ngIf="isOpen" role="region" aria-label="Notificaciones">
  <div class="drawer-header">
    <div>
      <h5>Notificaciones</h5>
      <p class="drawer-subtitle">Últimas alertas del equipo</p>
    </div>
    <button class="close-btn" (click)="onClose()" aria-label="Cerrar notificaciones" title="Cerrar" matRipple>
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="drawer-body">
    @if (headerFacade.notifications().length > 0) {
      @for (notification of headerFacade.notifications(); track notification.id) {
        <div class="drawer-notif" [class.unread]="!notification.read" role="article">
          <div class="notif-meta">
            <span class="notif-title">{{ notification.title }}</span>
            <span class="notif-badge">{{ notification.pinned ? 'Fijo' : 'Nuevo' }}</span>
          </div>
          @if (notification.description) {
            <div class="notif-desc">{{ notification.description }}</div>
          }
          <div class="notif-actions">
            @if (!notification.read) {
              <button class="btn-link" (click)="headerFacade.markNotificationAsRead(notification.id)" matRipple>
                Marcar leída
              </button>
            } @else {
              <span class="read-status-label"><i class="bi bi-check-all"></i> Leída</span>
            }
          </div>
        </div>
      }
      <div class="drawer-footer">
        <button class="btn btn-sm" (click)="headerFacade.markAllAsRead()" matRipple>
          Marcar todas como leídas
        </button>
      </div>
    } @else {
      <div class="no-notifs">No hay notificaciones</div>
    }
  </div>
</aside>
